import constate from 'constate'
import { EntityId, TemporalEntityId } from 'entities-next/common'
import { QueryFunctionContext, QueryStatus, useQuery } from 'react-query'

import { getApiUserHandlers, newUser, User, USER_CACHE_STORE_ID } from '../../../../../../entities-next/user'

export type UserDetailsViewStore = {
  state: {
    userId: number
    user?: User
    actionBarRef: React.MutableRefObject<any>
    status: QueryStatus
  }
}

function useUserDetailsViewInternalStore({
  userId,
  actionBarRef,
}: Pick<UserDetailsViewStore['state'], 'userId' | 'actionBarRef'>): UserDetailsViewStore {
  const userData = useUserEntity(userId)
  return {
    state: { actionBarRef, ...userData },
  }
}

function useUserEntity(userId: EntityId) {
  const { data: user, status } = useQuery([USER_CACHE_STORE_ID, userId], userQuery, {
    refetchOnWindowFocus: false,
  })

  return {
    userId: userId,
    user,
    status,
  }
}

async function userQuery({ queryKey }: QueryFunctionContext<[string, EntityId]>): Promise<User> {
  const [, userId] = queryKey
  const isNewUser = userId === TemporalEntityId.new
  const { apiGetUser } = getApiUserHandlers()
  return !isNewUser ? apiGetUser(userId) : newUser()
}

export const [UserDetailsViewProvider, useUserDetailsViewStore] = constate(useUserDetailsViewInternalStore)
